import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserStoreService } from './user-store.service';

export interface EmailTranslationsResponse {
  global: Translation[];
	survey: Translation[];
}

export interface Translation {
  id: string;
  translationID: string;
  textValue: string;
}

type EmailTranslationResult = {
  status: "OK" | "KO";
  code: "UPDATE" | "CREATE" | "NOP" | "ERR001" | "GE";
  shortDescription: string;
  fullDescription: string;
};

export interface ApiPutEmailTranslationsResponse {
  applied: string[];
  failed: { id: string, reason: string }[];
}

@Injectable({ providedIn: 'root' })
export class ApiEmailTranslationsService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/emailtranslations';

  constructor(
    private http: HttpClient,
    private userStore: UserStoreService) {}

  getTranslations(organizationId: string, culture: string): Observable<EmailTranslationsResponse> {
    return this.http.get<EmailTranslationsResponse>(`${this.apiBaseUrl}${this.apiPath}/${organizationId}/${culture}`)
  }

  updateTranslations(organizationId: string, translations: {id: string, textValue: string}[]): Observable<ApiPutEmailTranslationsResponse> {
    //Prevent update of other surveys during development, unless the user is a SuperAdmin
    if(organizationId != 'a535f93d-f8c7-421d-a9c9-74f7a17e3761' && !this.userStore.isSuperAdmin()){
      return throwError(() => new Error('This organization/survey is not editable.'));
    }

    return this.http.put<ApiPutEmailTranslationsResponse>(`${this.apiBaseUrl}${this.apiPath}/${organizationId}`, translations);
  }
}